import React, { useState } from "react";
import { Reveal } from "./Reveal";
import { Modal, SponsorshipForm } from "./Forms";
import { Plus } from "lucide-react";

const TIERS = [
  { name: "Title Partner", perk: "Exclusive National Branding" },
  { name: "Powered By Partner", perk: "Category Exclusivity" },
  { name: "Associate Partners", perk: "National Visibility" },
  { name: "State Partners", perk: "Regional Branding" },
  { name: "Education Partners", perk: "Fashion Institutes" },
  { name: "Textile Partners", perk: "Fabric Manufacturers" },
  { name: "Hospitality Partners", perk: "Hotels & Airlines" },
  { name: "Media Partners", perk: "Television & Digital" },
];

export const Sponsorship = () => {
  const [open, setOpen] = useState(false);
  const [tier, setTier] = useState("");

  const openTier = (t) => { setTier(t); setOpen(true); };

  return (
    <section id="partners" data-testid="partners-section" className="relative khadi-tex bg-[#f2ece0] py-28 md:py-40 px-5 md:px-10">
      <div className="mx-auto max-w-[1600px]">
        <div className="grid md:grid-cols-12 gap-8 items-end mb-14">
          <div className="md:col-span-8">
            <Reveal>
              <p className="font-display text-[11px] tracking-[0.3em] uppercase text-[#a65a34] mb-6">(09) Partnership Opportunities</p>
              <h2 className="font-serif text-4xl md:text-7xl leading-[0.96] tracking-tight">
                Put your brand on India&apos;s <span className="italic">heritage runway.</span>
              </h2>
            </Reveal>
          </div>
          <div className="md:col-span-4">
            <Reveal delay={0.15}>
              <p className="font-body text-sm text-black/60 leading-relaxed">
                Eight tiers of association — from exclusive national title rights to regional and
                category partnerships. Select a tier to begin the conversation.
              </p>
            </Reveal>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {TIERS.map((t, i) => (
            <Reveal key={t.name} delay={(i % 4) * 0.06}>
              <button
                data-testid={`tier-${i}`}
                onClick={() => openTier(t.name)}
                className="group h-full w-full text-left border border-black/12 p-7 md:p-8 min-h-[200px] flex flex-col justify-between transition-colors duration-500 hover:bg-[#1a130b] hover:text-[#f2ece0]"
              >
                <div className="flex items-center justify-between">
                  <span className="font-display text-[10px] tracking-[0.25em] uppercase opacity-40">{String(i + 1).padStart(2, "0")}</span>
                  <Plus size={18} className="transition-transform duration-500 group-hover:rotate-90 text-[#a65a34]" />
                </div>
                <div>
                  <h3 className="font-serif text-2xl md:text-3xl leading-tight tracking-tight">{t.name}</h3>
                  <p className="mt-3 font-display text-[10px] uppercase tracking-[0.18em] opacity-60">{t.perk}</p>
                </div>
              </button>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.1} className="mt-12">
          <button
            data-testid="general-sponsor-btn"
            onClick={() => openTier("")}
            className="btn-invert group inline-flex items-center gap-3 border border-[#2a2018] px-8 py-4 font-display text-[12px] uppercase tracking-[0.25em] text-[#2a2018] transition-colors duration-300 hover:text-[#f2ece0]"
          >
            <span className="fill" />
            Become a Partner
          </button>
        </Reveal>
      </div>

      <Modal open={open} onClose={() => setOpen(false)} testid="sponsorship-modal" subtitle="Partnership Opportunities" title="Become a Partner">
        <SponsorshipForm presetTier={tier} onSuccess={() => setOpen(false)} />
      </Modal>
    </section>
  );
};

export default Sponsorship;
